import type { GoogleDriveFile } from './types';
import { googleFetch } from '../client';

export type GoogleDriveFilesUpdateRequest = {
  file_id: string;
  content: string;
  if_match?: string;
  revision?: string;
};

export type GoogleDriveFilesUpdateResponse = GoogleDriveFile;

export async function googleDriveFilesUpdate(
  params: GoogleDriveFilesUpdateRequest
): Promise<GoogleDriveFilesUpdateResponse> {
  return googleFetch<GoogleDriveFilesUpdateResponse>(
    '/rpc/google_drive_files_update',
    {
      body: params,
    }
  );
}
